import React, { useState, useEffect } from 'react';

import heroBg from '../../../assets/img/hero/hero-bg-img.png';
import heroNotificationOne from '../../../assets/img/hero/hero-notification-1.svg';
import heroNotificationTwo from '../../../assets/img/hero/hero-notification-2.svg';
import heroScrollIcon from '../../../assets/img/hero/hero-scroll-icon.svg';
import btnArrowIcon from '../../../assets/img/btn-arrow-icon.svg';
import appStoreBtn from '../../../assets/img/stores/download-app-store-black.svg';
import googlePlayBtn from '../../../assets/img/stores/download-google-play-black.png';

const Hero = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => setIsActive(true), []);

  return (
    <section id="hero" className={`hero-section ${isActive ? 'active' : ''}`}>
      <div className="bg-wrap">
        <img src={heroBg} alt="Bg" />
      </div>
      <div className="content-wrap">
        <div className="text-wrap">
          <h1 className="active-element">Invest with confidence</h1>
          <h6 className="active-element">
            ApeScreener is the web3 Super App to invest smarter, grow faster, and profit easier.
            <br />
            Powered by ApeScreener Intelligence.
          </h6>
        </div>
        <div className="stores-wrap active-element">
          <div className="store-button">
            <a
              href="https://apps.apple.com/us/app/apescreener-crypto-analytics/id6744605601"
              target="_blank"
              rel="noreferrer">
              <img src={appStoreBtn} alt="App Store" />
            </a>
          </div>
          <div className="store-button google">
            <a
              href="https://play.google.com/store/apps/details?id=com.apescreener.app"
              target="_blank"
              rel="noreferrer">
              <img src={googlePlayBtn} alt="Google Play" />
            </a>
          </div>
        </div>
        <div className="btn-wrap active-element">
          <a href="https://apescreener.app" target="_blank" rel="noreferrer" className="btn-main">
            <span className="text">Get your Edge</span>
            <span className="icon">
              <img src={btnArrowIcon} alt="Icon" />
            </span>
          </a>
        </div>
      </div>
      <div className="notification-wrap notification-1 active-element">
        <div className="img-wrap">
          <img src={heroNotificationOne} alt="Notification" />
        </div>
      </div>
      <div className="notification-wrap notification-2 active-element">
        <div className="img-wrap">
          <img src={heroNotificationTwo} alt="Notification" />
        </div>
      </div>
      <div className="scroll-wrap active-element">
        <img src={heroScrollIcon} alt="Scroll" />
      </div>
    </section>
  );
};

export default Hero;
